<script setup lang="ts">
import accountType from "@/types/account";

const emits = defineEmits(['openUpdateModal'])
const props = defineProps<{
  account: accountType;
  employeeCode: string;
}>();

</script>
<template>
  <button
    @click="emits('openUpdateModal', props.account, props.employeeCode)"
    class="material-symbols-outlined"
  >
    edit_note
  </button>
</template>
